import type { FormationDomaine, FormationNiveau } from '../types';

export const VILLES: string[] = ['Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger'];

export const DOMAINES: FormationDomaine[] = [
  'Implantologie',
  'Orthodontie',
  'Endodontie',
  'Parodontologie',
  'Esthétique dentaire',
  'Chirurgie orale',
  'Pédodontie',
];

export const NIVEAUX: FormationNiveau[] = ['Débutant', 'Intermédiaire', 'Avancé', 'Tous niveaux'];
